import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { useDropdownContext as I } from "../../contexts/Dropdown/context.js";
import { ExploreListItemsContainer as L, ExploreListItemsTitle as d, ExploreListItemsTitleIcon as E, ExploreListItemsContent as a, ExploreListItemLink as f, ExploreListItem as h } from "./style.js";
import { useTranslation as u } from "../../hooks/useTranslation/index.js";
import { Grid2 as T } from "@pelando/fontawesome/icons";
function N({
  exploreItems: i,
  containerClassName: s,
  hasTitle: m
}) {
  const { closeDropdown: n } = I(), { t: l } = u("common");
  return /* @__PURE__ */ r(L, { className: s, children: [
    m && /* @__PURE__ */ r(d, { children: [
      l("explore-list-items-title"),
      /* @__PURE__ */ t(E, { icon: T, role: "img" })
    ] }),
    /* @__PURE__ */ t(a, { children: i.map(({ text: o, icon: p, onClick: e, url: x, className: c }) => /* @__PURE__ */ t(
      f,
      {
        url: x,
        onClick: () => {
          e == null || e(), n();
        },
        children: /* @__PURE__ */ t(h, { className: c, icon: p, text: o })
      },
      o
    )) })
  ] });
}
export {
  N as ExploreListItems
};
